import SingleStopSearch from "../components/StopPage/SingleStopSearch";

export default function StopSearch() {
  return (
    <>
      <SingleStopSearch />
    </>
  );
}
